module.exports = __webpack_public_path__ + "static/media/reshotIcon.49950ab5.svg";